import { Routes, Route } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import TestPlanGenerator from './pages/TestPlanGenerator'
import VirtualRoomCreator from './pages/VirtualRoomCreator'
import AdminUsers from './pages/AdminUsers'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'

import BugReportCreator from './pages/BugReportCreator';

function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/test-plan" element={<TestPlanGenerator />} />
          <Route path="/virtual-room" element={<VirtualRoomCreator />} />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requireAdmin>
                <AdminUsers />
              </ProtectedRoute>
            }
          />
          <Route path="/bug-report" element={<BugReportCreator />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}

export default App